import { MGPValidation, Utils } from '@everyboard/lib';
import { MoveCoordToCoord } from '../../jscaip/MoveCoordToCoord';
import { TaflFailure } from './TaflFailure';
export class TaflMove extends MoveCoordToCoord {
    static isValidDirection(start, end) {
        const dir = start.getDirectionToward(end);
        if (dir.isFailure() || dir.get().isDiagonal()) {
            return MGPValidation.failure(TaflFailure.MOVE_MUST_BE_ORTHOGONAL());
        }
        return MGPValidation.SUCCESS;
    }
    constructor(start, end) {
        super(start, end);
        const maximalDistance = this.getMaximalDistance();
        Utils.assert(start.isInRange(maximalDistance, maximalDistance), 'Starting coord of TaflMove must be on the board, not at ' + start.toString() + '.');
        Utils.assert(end.isInRange(maximalDistance, maximalDistance), 'Landing coord of TaflMove must be on the board, not at ' + end.toString() + '.');
    }
    toString() {
        return 'TaflMove(' + this.getStart() + '->' + this.getEnd() + ')';
    }
}
